import axiosClient from './axiosClient'
import { REQUEST_BUILDER } from '../constant'
import config from '../config'
import { v4 as uuidv4 } from 'uuid'

const request = {
  get: ({ url, baseUrl, params, disabledLoading, disableAutoError, clientId }) => {
    return axiosClient({
      baseURL: baseUrl || config.apiUrl,
      url: url,
      method: REQUEST_BUILDER.GET,
      ...(params && { params: params }),
      disabledLoading: disabledLoading,
      disableAutoError: disableAutoError,
      customHeaders: {
        'x-request-id': uuidv4(),
        'X-IBM-Client-Id': clientId || config.xIbmClientId,
      },
    })
  },
  post: ({ url, baseUrl, data, disabledLoading, disableAutoError, clientId }) => {
    return axiosClient({
      baseURL: baseUrl || config.apiUrl,
      url: url,
      method: REQUEST_BUILDER.POST,
      ...(data && { data: data }),
      disabledLoading: disabledLoading,
      disableAutoError: disableAutoError,
      customHeaders: {
        'x-request-id': uuidv4(),
        'X-IBM-Client-Id': clientId || config.xIbmClientId,
      },
    })
  },
  delete: ({ url, baseUrl, data, disabledLoading, disableAutoError, clientId }) => {
    return axiosClient({
      baseURL: baseUrl || config.apiUrl,
      url: url,
      method: REQUEST_BUILDER.DELETE,
      ...(data && { data: data }),
      disabledLoading: disabledLoading,
      disableAutoError: disableAutoError,
      customHeaders: {
        'x-request-id': uuidv4(),
        'X-IBM-Client-Id': clientId || config.xIbmClientId,
      },
    })
  },
  put: ({ url, baseUrl, data, disabledLoading, disableAutoError, clientId }) => {
    return axiosClient({
      baseURL: baseUrl || config.apiUrl,
      url: url,
      method: REQUEST_BUILDER.PUT,
      ...(data && { data: data }),
      disabledLoading: disabledLoading,
      disableAutoError: disableAutoError,
      customHeaders: {
        'x-request-id': uuidv4(),
        'X-IBM-Client-Id': clientId || config.xIbmClientId,
      },
    })
  },
}
export default request
